import React, { Component } from 'react'
import { hot } from 'react-hot-loader'
import queryString from 'query-string';
import axios from 'axios';
import './style.scss'


class Invite extends Component {
  constructor(props) {
    super(props);
    this.state = {
      err: null,
      sent: false,
      fromEmail: null
    };
  }

  componentDidMount(){
    const parsedHash = queryString.parse(location.hash);
    if(parsedHash.e){
      this.setState({
        fromEmail: parsedHash.e
      })
      window.history.replaceState(null, null, window.location.pathname);
    }
  }
  

  
  _onSubmit(e){
    e.preventDefault();
    let fromAddress = this.state.fromEmail ? this.state.fromEmail : this.refs.fromAddress.value
    if(!validateEmail(fromAddress) || !validateEmail(this.refs.toAddress.value)){
      this.setState({
        err: 'Please enter a valid email address.'
      })      
      return;
    } else {
      this.setState({
        err: null
      })     
    } 


    this.setState({
      signedUp: true,
      sent: true
    })


    axios.post('https://v77dfjbz5l.execute-api.us-east-1.amazonaws.com/prod/invite', {
      fromAddress: fromAddress,
      toAddress: this.refs.toAddress.value,
      message: this.refs.message.value
    })
    .then(function (response) {
    })
    .catch(function (error) {
      console.log(error);
    });


    function validateEmail(email) {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(String(email).toLowerCase());
    }
  }

  render () {
    return (
      <div className="invite">
        <div className="content-wrapper center">


          <div className="intro">
            <h2>toos is made for two.</h2>
            <h3>Let's begin by inviting your partner to join your toos account.</h3>
          </div>

          <div className="sign-up invite" name="invite">


            {!this.state.sent ? (
              <form onSubmit={this._onSubmit.bind(this)}>
                <div>
                  
                  { this.state.fromEmail === null && (
                    <div className="form-row">
                      <label htmlFor="fromAddress">Your email address</label>
                      <input 
                        type="text"
                        placeholder="Your email address"
                        ref="fromAddress"
                        name="fromAddress"
                      />  
                    </div>
                  )}

                  <div className="form-row">
                    <label htmlFor="toAddress">Your partners email address</label>
                    <input 
                      type="text"
                      placeholder="Their email address"
                      ref="toAddress"
                      name="toAddress"
                    />  
                  </div>

                  <div className="form-row">
                    <label htmlFor="message">Your invite message</label>
                    <textarea 
                      type="text"
                      placeholder={`Hey! \nDelete the spreadsheet! I think this might make our lives alot easier 😀!`}
                      ref="message"
                      name="message"
                      rows="6"
                    />  
                  </div>

                  <button onClick={this._onSubmit.bind(this)}>
                    <span>Send Invite</span>
                  </button>
                </div>
              </form>
              ) : (
                <div className="suc">
                  <h4>👍<br/>{`We've invited ${this.refs.toAddress.value} to your new toos account.`}<br/>We'll be in contact with next steps once they've accepted.</h4>
                  
                </div>
              )}

              {this.state.err && <span className='err'>{this.state.err}</span>}
              

            </div>


      </div>

      </div>
    )
  }
}

export default hot(module)(Invite)



// WEBPACK FOOTER //
// /Users/grantmaclennan/code/_archive/Toos/src/pages/Invite/index.js